@if (priority) {
	<img
		[ngSrc]="src"
		[alt]="alt"
		[fill]="true"
		[priority]="priority"
		[width]="width"
		[height]="height"
	/>
} @else {
	<img [ngSrc]="src" [alt]="alt" [fill]="true" [width]="width" [height]="height" loading="lazy" />
}
